import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

import Wrapper from './WrapperOLD';

import Button from '../../components/Button';
import { TemplateField } from '../../components/Attributes/Attributes_old';

import useAsync from '../../hooks/useAsync';
import { userResetToken } from '../../api';

const ForgotPassword = () => {
	const navigate = useNavigate();
	const [formState, setFormState] = useState({});
	const [error, setError] = useState(null);

	const { execute: onForgetPassword, status } = useAsync(userResetToken, {
		immediate: false,
		showNotification: { success: 'A link has been sent to your email' },
	});

	const message = error ? { type: 'error', value: error.message } : null;

	return (
		<Wrapper title="Forgot your password?" message={message || error}>
			<div className="space-y-6">
				<div className="mt-1">
					<TemplateField
						name="Email address"
						onChange={(dataIndex, email) =>
							setFormState({ ...formState, email })
						}
						autoFocus
					/>
				</div>
				<div className="flex justify-between">
					<Button
						type="ghost"
						className="flex-shrink-0"
						onClick={() => navigate('/login')}
					>
						Go back
					</Button>
					<Button
						type="primary"
						className="flex-shrink-0"
						onClick={() =>
							onForgetPassword(formState, () => navigate('/login'))
						}
					>
						{status === 'pending' ? 'Loading...' : 'Send Link'}
					</Button>
				</div>
			</div>
		</Wrapper>
	);
};

export default ForgotPassword;
